import {API} from '@/classes/api/api.class';
import {LeanDocument, Types} from 'mongoose';
import {FindByIdOptionsRequestDto} from '@/classes/dto/_common/request/FindByIdOptions.request.dto';
import {CreateUserSurveyRequestDto} from '@/classes/dto/survey-manager/request/CreateUserSurvey.request.dto';
import {FindUserSurveyRequestDto} from '@/classes/dto/survey-manager/request/FindUserSurvey.request.dto';
import {UserSurveyDocument} from '@/documentTypes/survey-manager/UserSurvey.document';
import store from '@/store';

import {GetSurveyDataRequestDto} from '@/classes/dto/survey-manager/request/GetSurveyData.request.dto';
import {
    AssignedInstitutionsSurveyDataResponseItem,
    GetSurveyDataResponseDto,
} from '@/classes/dto/survey-manager/response/GetSurveyData.response.dto';
import {SurveyItemType} from '@/enums/survey-manager/SurveyItemType.enum';
import {
    FindUserSurveyResponseRequestDto,
} from '@/classes/dto/survey-manager/request/responses/FindUserSurveyResponse.request.dto';
import {UserSurveyResponseDocument} from '@/documentTypes/survey-manager/UserSurveyResponse.document';
import {
    CreateUserSurveyResponseRequestDto,
} from "@/classes/dto/survey-manager/request/CreateUserSurveyResponse.request.dto";

export class SurveyManagerApi extends API {
    static service = 'survey-manager';

    static async create(newDocument: CreateUserSurveyRequestDto): Promise<Types.ObjectId> {
        return this.post(``, newDocument);
    }

    static async find(findQuery: FindUserSurveyRequestDto): Promise<{
        userSurveys: LeanDocument<UserSurveyDocument>[];
        maxPage: number
    }> {
        return this.get(``, findQuery);
    }

    static async findById(id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<UserSurveyDocument>> {
        return this.get(`id/${id}`, options);
    }

    static async remove(id: Types.ObjectId): Promise<void> {
        return this.delete(`id/${id}`);
    }

    static dataProvider = {
        getSurveyData: async (data: GetSurveyDataRequestDto): Promise<GetSurveyDataResponseDto> => {
            return this.get('data-provider', data);
        },
    }

    static response = {
        getAvailableSurveys: async (): Promise<LeanDocument<UserSurveyDocument> | undefined> => {
            const survey = await this.get('response/available') as LeanDocument<UserSurveyDocument> | undefined;
            if (survey) {
                // check if survey has editable fields, otherwise no dialog should be shown
                const surveyData = await SurveyManagerApi.dataProvider.getSurveyData({surveyId: survey._id});
                if (survey.items.length === 1 && survey.items[0].type === SurveyItemType.ASSIGNED_INSTITUTIONS_SELECTION) {
                    const item = surveyData.items.find((i) => i.type === SurveyItemType.ASSIGNED_INSTITUTIONS_SELECTION) as AssignedInstitutionsSurveyDataResponseItem | undefined;
                    if (item && item.currentInstitutions.length === 0 && item.availableInstitutions.length === 0) {
                        return;
                    }
                }
                store.commit('showSurveyDialog', {value: true, survey});
            }
            return survey;
        },
        createSurveyResponse: async (data: CreateUserSurveyResponseRequestDto): Promise<Types.ObjectId> => {
            return this.post('response', data);
        },
        findById: async (id: Types.ObjectId | string, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<UserSurveyResponseDocument>> => {
            return this.get(`response/${id}`, options);
        },
        find: async (findQuery: FindUserSurveyResponseRequestDto): Promise<{
            responses: LeanDocument<UserSurveyResponseDocument>[];
            maxPage: number
        }> => {
            return this.get('response', findQuery);
        },
    }

}
